import {
  type ReleaseSummaryWorkflow,
  type WorkflowStep,
  type WorkflowStepInput,
  WorkflowStepStatuses,
} from "~/api/types";

import { currentUserAtTopCompareFn, printFullName } from "./user";

export const progressRatio = ({
  completedSteps,
  totalSteps,
}: ReleaseSummaryWorkflow) =>
  totalSteps === 0 ? 0 : completedSteps / totalSteps;

export function mapStepInputsToWorkflowSteps(
  steps: WorkflowStepInput[],
): WorkflowStep[] {
  return steps.map((s, i) => ({
    id: s.id ?? -(i + 1),
    name: s.name,
    description: s.description ?? "",
    type: s.type,
    dueAt: s.dueAt,
    order: i,
    status: WorkflowStepStatuses.upcoming,
    users: s.users,
  }));
}

interface ExtractOwnerInput {
  userId: number;
  firstName: string;
  lastName?: string;
}

export function extractOwners(
  docs: ExtractOwnerInput[],
  currentUserId: number,
) {
  const ownerIds = new Set<number>();

  return docs
    .filter(({ userId }) => {
      if (ownerIds.has(userId)) {
        return false;
      } else {
        ownerIds.add(userId);
        return true;
      }
    })
    .toSorted((a, b) =>
      currentUserAtTopCompareFn(a.userId, b.userId, currentUserId),
    )
    .map((owner) => ({
      label: printFullName(owner, owner.userId === currentUserId),
      value: `${owner.userId}`,
    }));
}
